import { cn } from "../lib/utils";
import * as React from "react";
function LoadingBlock({ className, ...props }) {
    return (React.createElement("div", { className: cn("animate-opacity-pulse rounded-md", "bg-loading", className), ...props }));
}
export { LoadingBlock };
//# sourceMappingURL=LoadingBlock.js.map